import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { CheckBlacklistModal } from "@/components/modals/check-blacklist-modal";
import { useSession } from "@/hooks/use-session";
import { SERVICES } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { resetEasiRecharge } from "@/redux/slices/easi-recharge";
import { resetOrder, setOrder } from "@/redux/slices/order";

export default function Home() {
  const { t } = useTranslation();
  const { session } = useSession();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleTouristNavigate(service: (typeof SERVICES)[number]) {
    dispatch(
      setOrder({
        orderType: "New Order",
        hasExistingServiceProvider: false,
        internalPortin: false,
        customerType: service.customerType,
        citizenship: "Foreigner",
      })
    );
    navigate(`${service.href}/plans`);
  }

  useEffect(() => {
    dispatch(resetOrder());
    dispatch(resetEasiRecharge());
  }, []);

  return (
    <section className="space-y-6 py-6">
      <h1 className="text-pretty text-center text-2xl text-muted-foreground">
        {t("home.title")}
      </h1>
      <div className="flex flex-col flex-wrap items-center justify-center gap-6 sm:flex-row sm:gap-12">
        {SERVICES.map((service) =>
          service.customerType === "EASI-RECHARGE" ||
          service.customerType === "TOURIST" ? (
            <button
              className={cn(
                "w-48 cursor-pointer",
                service.requireLogin && !session && "hidden"
              )}
              key={service.label}
              onClick={() =>
                service.customerType === "TOURIST"
                  ? handleTouristNavigate(service)
                  : navigate(`${service.href}`)
              }
              type="button"
            >
              {/** biome-ignore lint/correctness/useImageSize: Automatic sizing */}
              <img alt={service.label} src={service.icon} />
            </button>
          ) : (
            <CheckBlacklistModal key={service.label} service={service}>
              <button
                className={cn(
                  "w-48 cursor-pointer",
                  service.requireLogin && !session && "hidden"
                )}
                type="button"
              >
                {/** biome-ignore lint/correctness/useImageSize: Automatic sizing */}
                <img alt={service.label} src={service.icon} />
              </button>
            </CheckBlacklistModal>
          )
        )}
      </div>
    </section>
  );
}
